<template>
  <v-hover
    v-slot:default="{ hover }"
  >
    <BaseMyCard
      v-bind="$attrs"
      v-on="$listeners"
      v-resize="onResize"
      class="ma-2"
      :select="jobSelected && jobSelected === job._id"
      :hover="hover"
    >
      <v-list-item
        class="px-8 py-4"
        v-if="!small && ((windowSize.x > 811 && windowSize.x < 1101) || windowSize.x > 1552 || (windowSize.x < 695 && windowSize.x > 556))"
        style="position: relative"
      >
        <div
          class="white"
          v-if="alreadyApplied"
          style="position: absolute; right: 20px; top: 20px"
        >
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn depressed color="white" small fab v-on="on">
                <v-icon
                  color="primary"
                >
                  mdi-check
                </v-icon>
              </v-btn>
            </template>
            <span>Hoja de vida enviada el {{ formatDate(alreadyApplied.createdAt) }}</span>
          </v-tooltip>
        </div>
        <div
          class="white"
          v-if="job.permitir_discapacitados"
          :style="`position: absolute; right: ${alreadyApplied ? '60px' : '20px'}; top: 20px`"
        >
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn depressed color="white" small fab v-on="on">
                <v-icon
                  color="grey darken-1"
                >
                  mdi-human-wheelchair
                </v-icon>
              </v-btn>
            </template>
            <span>Apto para personas con discapacidad</span>
          </v-tooltip>
        </div>
        <div class="d-flex flex-column align-center mr-4">
          <v-list-item-avatar
            size="64"
            :color="!job.empresa.profile_image ? 'primary' : ''"
            class="mt-4 d-flex justify-center"
          >
            <v-img
              v-if="!!job.empresa.profile_image"
              :src="`${host}${job.empresa.profile_image}`" :alt="job.empresa.nombre_empresa"
            ></v-img>
            <span v-else class="white--text headline font-weight-bold">
              {{ initials }}
            </span>
          </v-list-item-avatar>
          <v-chip
            v-if="job.requerimientos && job.requerimientos.salario && job.requerimientos.salario.mostrar"
            small
            color="success lighten-5"
            class="success--text"
          >
            <v-icon small>mdi-currency-usd</v-icon>{{ job.requerimientos.salario.salario_min }} - {{ job.requerimientos.salario.salario_max }}
          </v-chip>
        </div>
        <v-list-item-content>
          <v-list-item-title class="title font-weight-bold primary--text" v-text="job.titulo"></v-list-item-title>
          <v-list-item-subtitle class="mb-3">
            <span class="primary--text font-weight-bold" v-text="job.empresa.nombre_empresa"></span>
            <span class="font-weight-bold grey--text text--darken-1" v-text="` - ${job.provincia}, ${job.ciudad}`"></span>
          </v-list-item-subtitle>
          <v-list-item-subtitle class="mb-3 d-flex flex-wrap">
            <div class="mr-4">
              <span class="grey--text mr-2">Nivel</span>
              <span class="font-weight-bold grey--text text--darken-1" v-text="job.nivel"></span>
            </div>
            <div>
              <span class="grey--text mr-2">Tipo de puesto</span>
              <span class="font-weight-bold grey--text text--darken-1" v-text="job.tipo_trabajo"></span>
            </div>
          </v-list-item-subtitle>
          <v-list-item-subtitle>
            <span class="font-weight-bold grey--text text--darken-1" v-text="`Publicado ${timeElapsed}`"></span>
          </v-list-item-subtitle>
        </v-list-item-content>
        <v-tooltip right>
          <template v-slot:activator="{ on }">
            <div v-on="on" class="d-flex flex-column align-center justify-center align-self-end pb-3">
              <v-icon>mdi-account-group</v-icon>
              <span class="font-weight-bold grey--text text--darken-1">{{ job.vacantes }}</span>
            </div>
          </template>
          <span>Número de vacantes disponibles</span>
        </v-tooltip>
      </v-list-item>
      <div class="px-8 py-6" v-else>
        <div style="position: relative">
          <div
            v-if="alreadyApplied"
            class="white"
            style="position: absolute; right: -10px; top: -4px"
          >
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn depressed color="white" small fab v-on="on">
                  <v-icon
                    color="primary"
                  >
                    mdi-check
                  </v-icon>
                </v-btn>
              </template>
              <span>Hoja de vida enviada el {{ formatDate(alreadyApplied.createdAt) }}</span>
            </v-tooltip>
          </div>
          <div
            class="white"
            v-if="job.permitir_discapacitados"
            :style="`position: absolute; right: ${alreadyApplied ? '30px' : '-10px'}; top: -4px`"
          >
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn depressed color="white" small fab v-on="on">
                  <v-icon
                    color="grey darken-1"
                  >
                    mdi-human-wheelchair
                  </v-icon>
                </v-btn>
              </template>
              <span>Apto para personas con discapacidad</span>
            </v-tooltip>
          </div>
          
          <v-list-item-title class="title font-weight-bold primary--text" v-text="job.titulo"></v-list-item-title>
          <v-list-item-subtitle class="mb-1">
            <span
              v-if="user"
              class="font-weight-bold grey--text primary--text"
              v-text="`${job.empresa.nombre_empresa} - `"
            ></span>
            <span class="font-weight-bold grey--text text--darken-1" v-text="`${job.provincia}, ${job.ciudad}`"></span>
          </v-list-item-subtitle>
        </div>
        <div class="d-flex">
          <div class="d-flex flex-column align-center mr-2">
            <v-list-item-avatar
              size="64"
              :color="!job.empresa.profile_image ? 'primary' : ''"
              class="mt-4 d-flex justify-center"
            >
              <v-img
                v-if="!!job.empresa.profile_image"
                :src="`${host}${job.empresa.profile_image}`" :alt="job.empresa.nombre_empresa"
              ></v-img>
              <span v-else class="white--text headline font-weight-bold">
                {{ initials }}
              </span>
            </v-list-item-avatar>
            <v-chip
              v-if="job.requerimientos && job.requerimientos.salario && job.requerimientos.salario.mostrar"
              small
              color="success lighten-5"
              class="success--text"
            >
              <v-icon small>mdi-currency-usd</v-icon>{{ job.requerimientos.salario.salario_min }} - {{ job.requerimientos.salario.salario_max }}
            </v-chip>
          </div>
          <v-list-item-content class="py-0">
            <v-list-item-subtitle class="mb-1 d-flex">
              <span class="grey--text mr-2">Nivel</span>
              <span class="font-weight-bold grey--text text--darken-1" v-text="job.nivel"></span>
            </v-list-item-subtitle>
            <v-list-item-subtitle class="mb-1 d-flex">
              <span class="grey--text mr-2">Tipo de puesto</span>
              <span class="font-weight-bold grey--text text--darken-1" v-text="job.tipo_trabajo"></span>
            </v-list-item-subtitle>
            <v-list-item-subtitle class="mt-4">
              <span class="font-weight-bold grey--text text--darken-1" v-text="`Publicado ${timeElapsed}`"></span>
            </v-list-item-subtitle>
          </v-list-item-content>
          <v-tooltip right>
            <template v-slot:activator="{ on }">
              <div v-on="on" class="d-flex flex-column align-center justify-center align-self-end pb-3">
                <v-icon>mdi-account-group</v-icon>
                <span class="font-weight-bold grey--text text--darken-1">{{ job.vacantes }}</span>
              </div>
            </template>
            <span>Número de vacantes disponibles</span>
          </v-tooltip>
        </div>
      </div>
    </BaseMyCard>
  </v-hover>
</template>

<script>
import { windowSizeMixin } from '@/mixin/windowSizeMixin.js';
import config from '@/config';
export default {
  mixins: [windowSizeMixin],
  props: {
    job: {
      type: Object,
      required: true,
    },
    user: {
      type: Object,
      required: false,
    },
    jobSelected: {
      type: String,
    },
    type: {
      type: String,
      default: 'list2'
    },
    small: {
      default: false,
    },
  },
  data() {
    return {
      host: config.host,
    };
  },
  computed: {
    timeElapsed() {
      return this.$moment(this.job.createdAt).fromNow();
    },
    initials() {
      const nombreEmpresa = this.job.empresa.nombre_empresa;
      const nombreSplit = nombreEmpresa.split(' ');
			if (nombreSplit.length === 1) return nombreEmpresa[0].toUpperCase();
			else return `${nombreEmpresa[0].toUpperCase()}${nombreEmpresa[1].toUpperCase()}`;
    },
    alreadyApplied() {
      return this.user ? this.job.postulantes.find(postulante => postulante.postulante === this.user._id) : undefined;
    },
  },
  methods: {
    formatDate(date) {
      return this.$moment(date).format('DD/MM/YYYY');
    },
  }
}
</script>

<style>

</style>